import styled from 'styled-components';

export const PostEditWrapper = styled.section`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 12px;
  flex: 1 1 auto;
  position: relative;
  padding: 20px 16px 0;
`;
